import React from "react";
import { Tab } from 'react-tabs'


const TabRugrats = (props) => {
	const {classes, tabStyling, icon, newAssetCount, label} = props
	return (
		<Tab className={classes} style={tabStyling}>
			<div className="top-border"></div>
			<div className="shape"></div>
			<div className="tab-content">
				<img src={icon} alt=""/>
				<h2>{label}</h2>
				{newAssetCount > 0 &&
					<span>{newAssetCount}</span>
				}
			</div>
		</Tab>
	)
}

export default TabRugrats